import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Credly|Templates|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

type LocNameStart = 'SPToolCredlyTemplatesDuplicateIds';
export type SPToolCredlyTemplatesDuplicateIdsLocNames =
	| `${LocNameStart}NotificationAnnouncement`
	| `${LocNameStart}TitleTable`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelTemplateId`
	| `${LocNameStart}LabelCatalogId`;

export const spToolCredlyTemplatesDuplicateIdsLocs: LocDefs<SPToolCredlyTemplatesDuplicateIdsLocNames> =
	{
		SPToolCredlyTemplatesDuplicateIdsNotificationAnnouncement: {
			defaultValue:
				'The same Credly Badge is associated with multiple credentials being issued by CM Connect. This can potentially impact candidates receiving badges. Please contact your Project Manager for assistance.',
			description: 'A message shown when there are duplicate Credly IDs.',
			displayPath: `${pathStart}Duplicate IDs`,
			displayType: 'Notification',
			...sharedProperties,
		},
		SPToolCredlyTemplatesDuplicateIdsTitleTable: {
			defaultValue: 'Credly Templates with duplicate IDs',
			description: 'Table title',
			displayPath: `${pathStart}Table title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPToolCredlyTemplatesDuplicateIdsLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPToolCredlyTemplatesDuplicateIdsLabelType: {
			defaultValue: 'Type',
			description: 'Column heading for: Type.',
			displayPath: `${pathStart}Type`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPToolCredlyTemplatesDuplicateIdsLabelTemplateId: {
			defaultValue: 'Template ID',
			description: 'Column heading for: Template ID.',
			displayPath: `${pathStart}Template ID`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPToolCredlyTemplatesDuplicateIdsLabelCatalogId: {
			defaultValue: 'Certmetrics ID',
			description: 'Column heading for: Certmetrics ID.',
			displayPath: `${pathStart}Certmetrics ID`,
			displayType: 'Label',
			...sharedProperties,
		},
	};

export type SPToolCredlyTemplatesDuplicateIdsLocType =
	LocMap<SPToolCredlyTemplatesDuplicateIdsLocNames>;
